import { render } from "./SubBlockLink.vue?vue&type=template&id=78162e56&ts=true"
import script from "./SubBlockLink.vue?vue&type=script&lang=ts"
export * from "./SubBlockLink.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__